import { useCallback } from "react";
import { formatCurrency, sanitizeNumberInput } from "../../../../utils/format";

export const useCurrencyFormat = (formData, setFormData) => {
  const handleCurrencyBlur = useCallback(
    (field, cleanedValue) => {
      // Use the cleaned value passed from ControlledField, or fall back to formData
      const raw = cleanedValue !== undefined ? cleanedValue : String(formData[field] || "").trim();

      // Determine decimals based on field name - rate fields need 4 decimals.
      // monthsTaxes/monthsIns/daysInterest are plain day/month counts, not
      // currency, so they get 0 — matched on the exact final name segment
      // (not a substring) so this doesn't also catch daysInterestAmount,
      // which is a real dollar figure and should stay at 2 decimals.
      const lastSegment = field.split(".").pop();
      const isRateField = field.includes("rate") || field.includes("Rate");
      const isWholeNumberField = ["monthsTaxes", "monthsIns", "daysInterest"].includes(
        lastSegment,
      );
      const decimals = isRateField ? 4 : isWholeNumberField ? 0 : 2;

      const cleaned = sanitizeNumberInput(raw, "", decimals);
      return cleaned ? formatCurrency(cleaned, { decimals }) : "";
    },
    [formData]
  );

  return handleCurrencyBlur;
};

